import React from 'react'
import Header from '../Integration/Header'
import FooterMenu from '../Integration/FooterMenu'
import FbOrders from '../../Middleware/Firebase/FbOrders'

function PageUserOrders() {
  return (
    <div>
      <Header/>
      <FbOrders/>
      <FooterMenu />
    </div>
  )
}

export default PageUserOrders